export default __webpack_public_path__ + "static/media/screen3.44f3a003.png";